import { createFileRoute } from '@tanstack/react-router';
import { LegalNotices } from '@/features/content/LegalNotices';

export const Route = createFileRoute('/_app/legal-notices')({ component: LegalNotices });
